import { FC } from 'react';
import { Flex, Text, Stack, Box } from '@mantine/core';
import { getFormattedDate } from '@utils/dates';
import { NEWS_HEADER_IMAGE } from 'src/mockdata';
import { LastNewsCardProps } from './types';
import Link from 'next/link';
import Image from 'next/image';

export const LastNewsCard: FC<LastNewsCardProps> = ({ news }) => {
  return (
    <Link
      href={`/noticias/${news.category?.name}/${news.slug}`}
      style={{ textDecoration: 'none', width: '100%', overflow: 'hidden' }}
    >
      <Flex
        key={news.slug}
        w="100%"
        align="center"
        gap={16}
        direction={{ base: 'column', md: 'row' }}
        mb={{ base: 32, sm: 16 }}
      >
        <Box
          pos="relative"
          miw={{ md: '20%' }}
          w={{ base: '100%', md: '20%' }}
          h={{ base: 200, md: 150 }}
        >
          <Image
            style={{ objectFit: 'cover' }}
            fill
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            objectFit="cover"
            src={news.header_image?.key ?? NEWS_HEADER_IMAGE}
            alt={news.title}
          />
        </Box>
        <Stack spacing="xs" w={{ base: '100%', md: '80%' }}>
          <Stack spacing={2}>
            {news.publish_at && (
              <Text variant="caption2">
                {getFormattedDate(news.publish_at)}
              </Text>
            )}
            <Text variant="subtitle1" lineClamp={1}>
              {news.title}
            </Text>
          </Stack>
          <Text variant="bodyBold" lineClamp={3}>
            {news.sub_title || news.description_text?.text}
          </Text>
        </Stack>
      </Flex>
    </Link>
  );
};
